import { Component } from '@angular/core';
import { EkButtonComponent } from '@beta-foundations/ui-kit/buttons';
import { EkDialogBodyComponent, EkDialogFooterComponent, EkDialogHeaderComponent } from '@beta-foundations/ui-kit/overlay/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-delete-confirmation',
  standalone: true,
  imports: [
    EkDialogHeaderComponent,
    EkDialogBodyComponent,
    EkDialogFooterComponent,
    EkButtonComponent,
    TranslateModule
  ],
  templateUrl: './delete-message.component.html',
  styleUrl: './delete-message.component.scss'
})
export class DeleteMessageComponent {

  public disableConfirmation: boolean = false;
  
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    if (this.config.data && 'disableConfirmation' in this.config.data) {
        this.disableConfirmation = this.config.data.disableConfirmation;
    }
  }

  get message(): string {
    return this.config.data?.message || 'Are you sure you want to delete this item?';
  }

  get title(): string {
    return this.config.data?.title || 'LABELS.ATTENTION';
  }

  onConfirm() {
    if (!this.disableConfirmation) { 
        this.ref.close(true);
    }
  }

  onCancel() {
    this.ref.close(false);
  }
}